
export class KYMW0909InputModel {
  // モード：追加
  public static MODE_ADD = 1;

  // モード：詳細
  public static MODE_DETAIL = 2;

  // モード：閲覧
  public static MODE_READ_ONLY = 3;

  // モード
  public mode: number = null;

  // 遷移元から受け取る会員タブのアイテムコードリスト
  public coopInfoItemCoopCode = [];

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // 注文コード割当コード
  public pointExchangeOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public pointExchangeOrderNumQuotaCodeList = [];

  // ポイント交換注文コード
  public pointExchangeOrderNum = '';

  // 専用商品名
  public pointExchangeGoodsName = '';

  // 専用商品名(カナ)
  public pointExchangeGoodsNameKana = '';

  // 専用規格名
  public pointExchangeGuideName = '';

  // 専用規格名(カナ)
  public pointExchangeGuideNameKana = '';

  // ポイント不足エラー区分
  public shortOfPointDiv = '';

  // ECのみフラグ
  public ecOnlyFlg = '';

  // 消費税率
  public consumeTaxRate: number = <number>0;

  // 消費税区分
  public consumeTaxDiv: string = <string>'';
  
  // ポイント購入時割引率一括設定値
  public pointRateAllSetting: string = <string>'';

  // 会員生協別ポイント一覧
  public coopPointRateList: Array<any> = new Array<any>();

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';

  // 登録済みのデータリスト
  public settedItemCodeList = [];

  // 会員生協別ポイント一覧（現状で登録されているデータ）
  public coopPointRateCurrentList: Array<any> = new Array<any>();
}
